
<template>
  <div class="error">
    <button class="btn" @click="click">去登录</button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: "加入社区",
      state: 1,
      remark: "",
    };
  },
  methods: {
    click() {
      this.getNthUserInfo();
    },

    getNthUserInfo() {
      this.$toast.loading({
        duration: 0,
        message: "加载中...",
      });
      SmartCity.getUserInfo((res) => {
        if (res && res.userInfo) {
          this.$toast.clear();
                            this.$store.commit("setNthUserId", res.userInfo.userid);

          location.reload();
      
        } else {
          this.$toast.clear();
          SmartCity.goLogin();
        }
      });
    },

    goBack() {
      SmartCity.goBack();
    },
  },

  created() {
    // SmartCity.hideTopView({
    //   isShow: 0,
    // });

    if (this.$store.state.m2oId) {
      this.$router.replace("/");
    } else {
      this.getNthUserInfo();
    }
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.error {
  width: 100%;
  .btn {
    margin-top: 50%;
    margin-left: 50%;
    transform: translateX(-50%);
  }
}
</style>
